import { Component, Inject } from '@angular/core';
import { SidenavContentModule } from '../../shared/sidenav/sidenav-content/sidenav-content.module';
import { PropertyManagementCompanyDataService } from '../../../../services/property-management-company/property-manager-company-data.service';
import { HeaderMenuProfile } from '../header-menu/header-menu.component';
import { SIDENAV_CONTENT_DATA } from '../../shared/sidenav/sidenav-content/sidenav-content.service';
import { HeaderMenuItemsComponent } from '../header-menu-items/header-menu-items.component';
import { AvatarBlockModule } from '../../shared/avatar-block/avatar-block.module';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SidenavContentRef } from '../../shared/sidenav/sidenav-content/sidenav-content-ref';

export interface HeaderMenuSidenavInput {
    profile: HeaderMenuProfile;
}

export interface HeaderMenuSidenavOutput {
    switchToNotifications?: boolean;
}

@Component({
    selector: 'app-header-menu-sidenav',
    templateUrl: './header-menu-sidenav.component.html',
    standalone: true,
    imports: [
        SidenavContentModule,
        HeaderMenuItemsComponent,
        AvatarBlockModule,
        MatIconModule,
        MatMenuModule,
    ],
})
export class HeaderMenuSidenavComponent
{
    constructor(
            private _propertyManagementCompanyData: PropertyManagementCompanyDataService,
            private _sidenavRef: SidenavContentRef<HeaderMenuSidenavComponent>,
            @Inject(SIDENAV_CONTENT_DATA) public data: HeaderMenuSidenavInput,
    ) {
    }

    get pmc$() {
        return this._propertyManagementCompanyData.pmc$;
    }

    switchToNotifications() {
        const output: HeaderMenuSidenavOutput = {
            switchToNotifications: true,
        };

        this._sidenavRef.close(output);
    }
}
